import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const opticaGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    // Solo usuarios de óptica (rol = 'usuario') pueden acceder
    if (!authService.isAdmin()) {
      return true;
    } else {
      // Si es administrador, redirigir al dashboard
      router.navigate(['/dashboard']);
      return false;
    }
  }

  // Si no está autenticado, redirigir al login
  router.navigate(['/login']);
  return false;
};
